<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    Additional Streams
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Stream</mat-label>
        <mat-select data-testid="selectedStreamId" [errorStateMatcher]="matcher" #streamCtrl="ngModel" [(ngModel)]="selectedStreamId" name="selectedStreamId" required (selectionChange)="getPriceMatrix()">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #streamSearchInput matInput placeholder="Search Stream..." (input)="filterStreams($event)"
                   class="mat-select-search-input" aria-label="Search Stream" (keydown)="$event.stopPropagation()" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option [value]="null">-Select Stream-</mat-option>
          @for (stream of filteredStreams; track stream.streamId) {
            <mat-option [value]="stream.streamId" [disabled]="stream.streamId < 0">
              {{ stream.name }}
            </mat-option>
          }
          @if (filteredStreams.length === 0) {
            <mat-option disabled>No results found</mat-option>
          }
        </mat-select>
        @if (attemptSave() && streamCtrl.invalid) {
        <mat-error>Stream is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Unit of Measure (UOM)</mat-label>
        <mat-select data-testid="selectedUomId" [errorStateMatcher]="matcher" #uomCtrl="ngModel"
          [(ngModel)]="selectedUomId" name="selectedUomId" required [disabled]="isUOMDisabled" (selectionChange)="onUOMChange($event.value)">
          <mat-option [value]="null">-Select UOM-</mat-option>
          @for (uom of availableUoms; track uom.id) {
            <mat-option [value]="uom.id">{{ uom.name }}</mat-option>
          }
          @if (availableUoms.length === 0) {
            <mat-option disabled>No results found</mat-option>
          }
        </mat-select>
        @if (attemptSave() && uomCtrl.invalid) {
          <mat-error>UOM is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Tip Fee</mat-label>
        <input data-testid="tipFee" matInput type="number" #tipCtrl="ngModel" [errorStateMatcher]="matcher" disabled="true" [(ngModel)]="tipFee" name="tipFee" required 
          (keydown)="preventArrowKeyChange($event)" />
        @if (attemptSave() && uomCtrl.invalid) {
          <mat-error>UOM is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Quantity</mat-label>
        <input data-testid="quantity" matInput type="text" [errorStateMatcher]="matcher" #qtyCtrl="ngModel" [(ngModel)]="quantity" name="quantity" required
               (input)="roundOff($event, 999999, 4, 1)" />
        @if (attemptSave() && qtyCtrl.invalid) {
        <mat-error>Quantity is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Rebate UOM</mat-label>
        <mat-select data-testid="selectedRebateUomId" [(ngModel)]="selectedRebateUomId" name="selectedRebateUomId"
                    disabled="true">
          <mat-option [value]="null">-Select UOM-</mat-option>
          @for (uom of availableRebateUoms; track uom.id) {
          <mat-option [value]="uom.id">{{ uom.name }}</mat-option>
          }
          @if (availableRebateUoms.length === 0) {
          <mat-option disabled>No results found</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Rebate Quantity</mat-label>
        <input data-testid="rebateQuantity" matInput type="text" [(ngModel)]="rebateQuantity" [disabled]="isRebateQtyDisabled"
          name="rebateQuantity" (input)="roundOff($event, 99999, 4, 2)" #rqtyCtrl="ngModel"
          [required]="selectedRebateUomId !== null && selectedRebateUomId !== 0" [errorStateMatcher]="matcher" />
        @if (attemptSave() && rqtyCtrl.invalid) {
          <mat-error>Rebate Quantity is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Rebate Amount</mat-label>
        <input data-testid="rebateValue" matInput type="number" [(ngModel)]="rebateValue" disabled="true"
            name="rebateValue" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Actual Tons</mat-label>
        <input data-testid="tons" matInput type="text" [(ngModel)]="tons" [disabled]="disableActualTons"
          name="tons" (input)="roundOff($event, 999999, 4, 3)" />
      </mat-form-field>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" mat-primary (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" mat-primary data-testid="btnaddtStreamSave" (click)="onSave()">Save</button>
</mat-dialog-actions>
